import { z } from "zod";

import { ERROR_TYPE } from "@/utils";

const { REQUIRED } = ERROR_TYPE;

export const CompanyRevenueSchema = z.object({
	id: z.number().optional(),
	value: z.string().min(1, { message: REQUIRED }),
});

export const CreateCompanyRevenueSchema = z.object({
	value: z.string().min(1, { message: REQUIRED }),
});

export const UpdateCompanyRevenueSchema = z.object({
	id: z.number(),
	value: z.string().min(1, { message: REQUIRED }),
});

export const DeleteCompanyRevenueSchema = z.object({
	id: z.number(),
});

export const CompanyRevenueArraySchema = z.array(CompanyRevenueSchema);

export type CompanyRevenue = z.infer<typeof CompanyRevenueSchema>;
export type CreateCompanyRevenue = z.infer<typeof CreateCompanyRevenueSchema>;
export type UpdateCompanyRevenue = z.infer<typeof UpdateCompanyRevenueSchema>;
export type DeleteCompanyRevenue = z.infer<typeof DeleteCompanyRevenueSchema>;
export type CompanyRevenueArray = z.infer<typeof CompanyRevenueArraySchema>;
